import * as React from 'react';
import classNames from 'classnames';

import * as styles from './HeaderStickyContent.css';

interface IHeaderStickyContentProps {
  title: string;
  published: boolean;
  price?: string;
  phone: React.ReactNode;
}

export const HeaderStickyContent: React.FC<IHeaderStickyContentProps> = ({ title, price, published, phone }) => {
  return (
    <div className={styles['content']}>
      <div className={styles['title']}>{title}</div>
      {price && <div className={classNames(styles['price'], !published && styles['price--unpublished'])}>{price}</div>}
      <div className={styles['phone']}>{phone}</div>
    </div>
  );
};
